"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungFormValidator = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
class LeitungFormValidator {
    static leitungslaenge(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0.01,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.m;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0.03,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.ft;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static ueberstandFestpunkt(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualMinLessMaxValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            thresholdMin: 0.01,
            thresholdMax: 1000,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.m;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualMinLessMaxValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            thresholdMin: 0.03,
            thresholdMax: 3280.84,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.ft;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityRangeValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static ueberstandMitnehmer(options) {
        return this.ueberstandFestpunkt(options);
    }
    static biegeradiusMin(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 1,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.1,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.01,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.inch;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static aussendurchmesser(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0.01,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0.01,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.inch;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static gewicht(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 1,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.001,
        });
        const metricUnit = echain_shared_quantities_1.WeightPerLengthUnits.kg_km;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 3,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.001,
        });
        const imperialUnit = echain_shared_quantities_1.WeightPerLengthUnits.lbs_mft;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static gewichtKgProM(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired !== false,
            locale: options.languageTag,
            precision: 3,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.001,
        });
        const metricUnit = echain_shared_quantities_1.WeightPerLengthUnits.kg_m;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 3,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.001,
        });
        const imperialUnit = echain_shared_quantities_1.WeightPerLengthUnits.lbs_mft;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static kupferzahl(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 1,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.WeightPerLengthUnits.kg_km;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 3,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.WeightPerLengthUnits.lbs_mft;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
}
exports.LeitungFormValidator = LeitungFormValidator;
//# sourceMappingURL=LeitungFormValidator.js.map